/**
 * Feature flags configuration
 */
export const FEATURE_FLAGS = {
  INLINE_CATEGORY_CREATION: import.meta.env.VITE_FF_INLINE_CATEGORIES === 'true' || true, // Default to true for now
  FLEXIBLE_DRAFTING: import.meta.env.VITE_FF_FLEXIBLE_DRAFTS === 'true' || false,
  UNIFIED_STATUS_DROPDOWN: import.meta.env.VITE_FF_UNIFIED_STATUS === 'true' || false,
  // Add more feature flags as needed
};

/**
 * Check if a feature is enabled
 * @param {keyof typeof FEATURE_FLAGS} feature - Feature name
 * @returns {boolean} Whether the feature is enabled
 */
export function isFeatureEnabled(feature: keyof typeof FEATURE_FLAGS): boolean {
  return FEATURE_FLAGS[feature] || false;
}